import { render, staticRenderFns } from "./OpFrame.vue?vue&type=template&id=593df72b&scoped=true&"
import script from "./OpFrame.vue?vue&type=script&lang=js&"
export * from "./OpFrame.vue?vue&type=script&lang=js&"
import style0 from "./OpFrame.vue?vue&type=style&index=0&id=593df72b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593df72b",
  null
  
)

export default component.exports